/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PortalDocumentStatus } from './PortalDocumentStatus';
import {
    PortalDocumentStatusFromJSON,
    PortalDocumentStatusFromJSONTyped,
    PortalDocumentStatusToJSON,
    PortalDocumentStatusToJSONTyped,
} from './PortalDocumentStatus';

/**
 * 
 * @export
 * @interface PortalDocument
 */
export interface PortalDocument {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    display_name: string;
    /**
     * 
     */
    status: PortalDocumentStatus;
    /**
     * 
     */
    request_item_ids: Array<string>;
    /**
     * 
     */
    file_count: number;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    participant_rejection_reason: string | null;
}



/**
 * Check if a given object implements the PortalDocument interface.
 */
export function instanceOfPortalDocument(value: object): value is PortalDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('request_item_ids' in value) || value['request_item_ids'] === undefined) return false;
    if (!('file_count' in value) || value['file_count'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('participant_rejection_reason' in value) || value['participant_rejection_reason'] === undefined) return false;
    return true;
}

export function PortalDocumentFromJSON(json: any): PortalDocument {
    return PortalDocumentFromJSONTyped(json, false);
}

export function PortalDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'display_name': json['display_name'],
        'status': PortalDocumentStatusFromJSON(json['status']),
        'request_item_ids': json['request_item_ids'],
        'file_count': json['file_count'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'participant_rejection_reason': json['participant_rejection_reason'],
    };
}

export function PortalDocumentToJSON(json: any): PortalDocument {
    return PortalDocumentToJSONTyped(json, false);
}

export function PortalDocumentToJSONTyped(value?: PortalDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'display_name': value['display_name'],
        'status': PortalDocumentStatusToJSON(value['status']),
        'request_item_ids': value['request_item_ids'],
        'file_count': value['file_count'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'participant_rejection_reason': value['participant_rejection_reason'],
    };
}

